/**
 * ViewContentSetCtrl controller
 */
import { SET_PRICING_PAYMENT_METHOD_TYPES_LABELS, SHOWSET_TYPES, CONTENT_SET_TYPES } from '../../app/core/constants'

/**
 * ViewContentSetCtrl controller
 *
 * @class ViewContentSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:ViewContentSetCtrl
 */
/* @ngInject */
export default function ViewContentSetCtrl ($uibModalInstance, cs, networkId, type, notTvDip) {
  var vm = this
  vm.ready = false
  vm.notTvDip = notTvDip

  vm.content_set_types = CONTENT_SET_TYPES

  vm.type = type
  switch (type) {
    case 'tvShowSet':
      vm.label = 'TV Show'
      break
    case 'vodSet':
      vm.label = 'VOD'
      break
    case 'liveEventSet':
      vm.label = 'Live Event'
      break
    case 'channelSet':
      vm.label = 'Channel'
      break
    case 'multiSet':
      vm.label = 'Multi'
  }

  vm.showSet_types = SHOWSET_TYPES
  vm.set_pricing_payment_method_types_labels = SET_PRICING_PAYMENT_METHOD_TYPES_LABELS

  /**
   * Channel Set
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {models.ChannelSet}
   */

  vm.cs = cs

  /**
   * Search content params with default values
   *
   * @memberof mwApp/packages.controller:ViewContentSetCtrl
   * @type {Object}
   */
  vm.searchContentParams = {
    page: 0,
    last: false
  }

  vm.getContent = function (params) {
    switch (type) {
      case 'tvShowSet':
        return vm.cs._getAssignedShows(networkId, vm.cs.id, 'content/assigned', { ...params })
      case 'vodSet':
        return vm.cs._getVodsAssigned({ ...params })
      case 'liveEventSet':
        return vm.cs._getAssignedLiveEvents(networkId, { ...params })
    }
  }

  if (['channelSet', 'multiSet'].includes(type)) {
    if (type === 'multiSet') {
      vm.multiSetsContent = {}
      vm.contentSetsTypes = Object.keys(CONTENT_SET_TYPES).filter(k => k !== 'multiSets')
      vm.contentSetsTypes = vm.contentSetsTypes.filter(key => vm.cs[key].length)
      vm.contentSetsTypes.forEach(key => {
        vm.multiSetsContent[key] = {
          is_open: true,
          sets: vm.cs[key]
        }
      })
    } else {
      vm.content = vm.cs.channels
    }
  } else {
    vm.getContent(vm.searchContentParams).then(data => {
      vm.content = data.content
      vm.searchContentParams.last = data.last
    })
  }

  vm.contentCallbackScroll = (event) => {
    if (type !== 'channelSet') {
      const {
        page,
        last
      } = vm.searchContentParams
      if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
        window.clearTimeout(vm.$timerContentScroll)
        vm.$timerContentScroll = window.setTimeout(() => {
          vm.getContent({ ...vm.searchContentParams, page: page + 1 }).then((result) => {
            vm.content = vm.content.concat(result.content)
            vm.searchContentParams.last = result.last
            vm.searchContentParams.page = result.number
          })
        }, 700)
      }
    }
  }

  /**
   * Filter value for channel sets
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {string}
   */
  vm.filter = ''

  /**
   * Filter assigned channels
   *
   * @param {Object} item
   * @memberof mwApp/packages.controller:ViewContentSetCtrl
   */
  vm.filteredContent = function (item) {
    return vm.filter.length > 0
      ? item.name.toLowerCase().includes(vm.filter.toLowerCase())
      : true
  }

  /**
   * Close modal window
   *
   * @memberof mwApp/package.controller:ViewContentSetCtrl
   */
  vm.close = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
